export enum Priority {
    LOW = 1,
    NORMAL = 2,
    HIGH = 3,
}
